import { useEffect, useState } from "react"
import "src/sections/capterra/Pricing.scss"
import SwiperCore, { Pagination } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.css"
import Button from "../../components/Form/Button"
import DefaultLayout from "src/layouts"

// Import banner images
import Banner from "./images/peoplevine-checkin-banner-desktop.jpg"
import Banner1 from "./images/BANNER 1.jpg"
import Banner2 from "./images/BANNER 2.jpg"
import Banner3 from "./images/BANNER 3.jpg"
import Banner4 from "./images/BANNER 4.jpg"
import Banner5 from "./images/BANNER 5.jpg"
import Banner6 from "./images/BANNER 6.jpg"
import Banner7 from "./images/BANNER 7.jpg"

// Import feature images
import Image1 from "./images/IMAGE 1.png"
import Image2 from "./images/IMAGE 2.png"
import Image3 from "./images/IMAGE 3.png"
import Image4 from "./images/IMAGE 4.png"
import Image5 from "./images/IMAGE 5.png"
import Image6 from "./images/IMAGE 6.png"
import Image7 from "./images/IMAGE 7.png"
import Image8 from "./images/IMAGE 8.png"
import Image9 from "./images/IMAGE 9.png"
import Image10 from "./images/IMAGE 10.png"
import Image11 from "./images/IMAGE 11.png"
import Image12 from "./images/IMAGE 12.jpg"

// Import mobile images
import MobileBanner from "./images/peoplevine-checkin-banner-mobile.jpg"
import MobileBanner1 from "./images/mobile/BANNER 1.jpg"
import MobileBanner2 from "./images/mobile/BANNER 2.jpg"
import MobileBanner3 from "./images/mobile/BANNER 3.jpg"
import MobileBanner4 from "./images/mobile/BANNER 4.jpg"
import MobileBanner5 from "./images/mobile/BANNER 5.jpg"
import MobileBanner6 from "./images/mobile/BANNER 6.jpg"
import MobileBanner7 from "./images/mobile/BANNER 7.jpg"

import MobileImage1 from "./images/mobile/IMAGE 1.png"
import MobileImage2 from "./images/mobile/IMAGE 2.png"
import MobileImage3 from "./images/mobile/IMAGE 3.png"
import MobileImage4 from "./images/mobile/image 4.png"
import MobileImage5 from "./images/mobile/IMAGE 5.png"
import MobileImage6 from "./images/mobile/image 6.png"
import MobileImage7 from "./images/mobile/IMAGE 7.png"
import MobileImage8 from "./images/mobile/IMAGE 8.png"
import MobileImage9 from "./images/mobile/IMAGE 9.png"
import MobileImage10 from "./images/mobile/IMAGE 10.png"
import MobileImage11 from "./images/mobile/IMAGE 11.png"
import MobileImage12 from "./images/mobile/IMAGE 12.png"

// Import webinar button
import WebinarButton from "./images/webinar-button.png"

// Import logo
import PeopleVineLogo from "./images/LOGO.png"

import "./CheckInPage.scss"
import { Link, useNavigate } from 'react-router-dom'


const CheckInPage = () => {
  const [isAnnual, setIsAnnual] = useState<boolean>(false)
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)
  const [activeSlide, setActiveSlide] = useState<number>(0) // State to track active slide
  const navigate = useNavigate()
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  SwiperCore.use([Pagination])

  const togglePaymentPeriod = () => {
    setIsAnnual(!isAnnual)
  }

  return (
    <DefaultLayout isHeaderFixed={true} isFooterAnimated={false} hasVideoBanner={false}>
      <section className='check-in-page-desktop'>
        {/* Full Width Banner */}
        <div className='banner-container'>
          <div className='banner-image'>
            <img 
              src={Banner} 
              alt="Check In Banner" 
              className='banner-img'
            />
          </div>
          <div className='banner-content'>
            <div className='banner-text-top'>
              <h1 className='banner-main-title'>CHECK-IN</h1>
              <p className='banner-main-subtitle'>AN ELEVATED "WELCOME" FOR HOSPITALITY BRANDS</p>
            </div>
            
            <div className='banner-text-bottom'>
              <p className='banner-description'>
                At PeopleVine, we believe every interaction matters.<br />
                That's why we created Check-in—our groundbreaking front-of-house app, developed in collaboration<br />
                with the world's most discerning clubs to redefine personalized service and guest recognition
              </p>
              <h2 className='banner-tagline'>A VIP WELCOME, EVERY TIME</h2>
            </div>
          </div>
        </div>

     {/* Easy & Convenient Section */}
       <div className='smart-tools-section'>
          {/* Banner with image and overlay text */}
          <div className='smart-tools-banner'>
            <div className='banner-image-container'>
              <img 
                src={Banner1} 
                alt="Easy & Convenient Banner" 
                className='smart-tools-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='smart-tools-title'>EASY & CONVENIENT MEMBER LOOKUP & CHECK - IN VIA SEARCH, CAMERA OR SCAN</h2>
              </div>
            </div>
          </div>

          {/* Three feature cards */}
          <div className='features-container'>
            <div className='feature-card'>
              <div className='feature-image-container'>
                <img src={Image1} alt="Search" className='feature-image' />
              </div>
              <div className='feature-content'>
                <h3 className='feature-title'>SEARCH</h3>
                <p className='feature-description'>
                  Quickly look up members by name or email with smart search functionality. Front-of-house staff can instantly access profiles, confirm reservations, and check members in—ensuring smooth arrivals with just a few keystrokes.
                </p>
              </div>
            </div>

            <div className='feature-card'>
              <div className='feature-image-container'>
                <img src={Image2} alt="Camera" className='feature-image' />
              </div>
              <div className='feature-content'>
                <h3 className='feature-title'>CAMERA</h3>
                <p className='feature-description'>
                  Enable seamless check-ins using camera recognition. Simply hold up a membership card or digital pass for instant member identification, reducing friction and making arrivals fast and contactless.
                </p>
              </div>
            </div>

            <div className='feature-card'>
              <div className='feature-image-container'>
                <img src={Image3} alt="Scan" className='feature-image' />
              </div>
              <div className='feature-content'>
                <h3 className='feature-title'>SCAN</h3>
                <p className='feature-description'>
                  Check in members with a simple tap or scan using NFC, QR codes or barcodes. Ideal for concierge desks and secure entry points. Fast, discreet and effortlessly elegant.
                </p>
              </div>
            </div>
          </div>
        </div>


        {/* Smart Tools Section */}
        <div className='smart-tools-section'>
          {/* Banner with image and overlay text */}
          <div className='smart-tools-banner'>
            <div className='banner-image-container'>
              <img 
                src={Banner2} 
                alt="Smart Tools Banner" 
                className='smart-tools-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='smart-tools-title'>SMART TOOLS FOR EXCEPTIONAL HOSPITALITY</h2>
              </div>
            </div>
          </div>

          {/* Three feature cards */}
          <div className='features-container'>
            <div className='feature-card'>
              <div className='feature-image-container'>
                <img src={Image4} alt="Check In Members" className='feature-image' />
              </div>
              <div className='feature-content'>
                <h3 className='feature-title'>CHECK IN MEMBERS WITH PHOTO FOR RECOGNITION</h3>
                <p className='feature-description'>
                  Instantly recognize members and streamline arrivals with real-time data delivered to your front-of-house. From greeting by name to guiding them to their table, service, or amenity. Check-in ensures every member feels like a VIP the moment they walk in.
                </p>
              </div>
            </div>

            <div className='feature-card'>
              <div className='feature-image-container'>
                <img src={Image5} alt="Guest Passes" className='feature-image' />
              </div>
              <div className='feature-content'>
                <h3 className='feature-title'>INNOVATIVE GUEST PASSES AND WAITLIST CAPABILITIES</h3>
                <p className='feature-description'>
                  Streamline guest pass management with real-time tracking and visibility. Linked to member profiles, it ensures every guest feels expected and valued—enhancing the experience from the moment they arrive.
                </p>
              </div>
            </div>

            <div className='feature-card'>
              <div className='feature-image-container'>
                <img src={Image6} alt="CRM Profiles" className='feature-image' />
              </div>
              <div className='feature-content'>
                <h3 className='feature-title'>POWERFUL CRM PROFILES</h3>
                <p className='feature-description'>
                  One-click access to detailed CRM profiles enables rapid retrieval of membership data, insights and preferences, empowering personalized service.
                </p>
              </div>
            </div>
          </div>
        </div>

       <div className='smart-tools-section'>
          {/* Banner with image and overlay text */}
          <div className='smart-tools-banner'>
            <div className='banner-image-container'>
              <img 
                src={Banner3} 
                alt="Smart Tools Banner" 
                className='smart-tools-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='smart-tools-title'>EMPOWER YOUR FRONT-OF-HOUSE TEAM</h2>
                <p className='banner-description-text'>Enhance the welcome experience by enabling your staff to greet members with personalized service.</p>
              </div>
            </div>
          </div>

          
        </div>

        {/* Features Details Section */}
        <div className='features-details-section'>
          <div className='features-details-container'>
            <div className='features-text-content'>
              <div className='feature-detail-item'>
                <div className='feature-detail-line'></div>
                <h3 className='feature-detail-title'>REFINED USER INTERFACE</h3>
                <p className='feature-detail-description'>
                  An intuitive and visually improved design streamlines usability, enhancing the experience for both staff and members.
                </p>
              </div>

              <div className='feature-detail-item'>
                <div className='feature-detail-line'></div>
                <h3 className='feature-detail-title'>REAL-TIME CHECK-IN VISIBILITY</h3>
                <p className='feature-detail-description'>
                  Track daily check-ins live, monitor member flow, and optimize staffing for peak times to enhance service delivery.
                </p>
              </div>

              <div className='feature-detail-item'>
                <div className='feature-detail-line'></div>
                <h3 className='feature-detail-title'>FLEXIBLE CHECK-IN POINTS</h3>
                <p className='feature-detail-description'>
                  Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
                </p>
              </div>
            </div>

            <div className='features-image-content'>
              <img src={Image7} alt="Features Interface" className='features-detail-image' />
            </div>
          </div>
        </div>


          <div className='smart-tools-section'>
          {/* Banner with image and overlay text */}
          <div className='smart-tools-banner'>
            <div className='banner-image-container'>
              <img 
                src={Banner4} 
                alt="Smart Tools Banner" 
                className='smart-tools-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='smart-tools-title'>BOOKING & RESERVATIONS</h2>
              </div>
            </div>
          </div>

          
        </div>


{/* Bookings & Reservations Details Section (Inverted) */}
        <div className='bookings-reservations-section'>
          <div className='bookings-container'>
            <div className='bookings-image-content'>
              <img src={Image8} alt="Bookings Scheduler Interface" className='bookings-image' />
            </div>

            <div className='bookings-text-content'>
              <h2 className='bookings-title'>BOOKINGS & RESERVATIONS DETAILS</h2>
              <p className='bookings-description'>
                Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
              </p>
            </div>
          </div>
        </div>
        {/* Bookings & Itinerary Section */}
        <div className='bookings-itinerary-section'>
          <div className='bookings-container'>
            <div className='bookings-text-content'>
              <h2 className='bookings-title'>BOOKINGS & ITINERARY</h2>
              <p className='bookings-description'>
                Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
              </p>
            </div>

            <div className='bookings-image-content'>
              <img src={Image9} alt="Bookings Interface" className='bookings-image' />
            </div>
          </div>
        </div>
    <div className='smart-tools-section'>
          {/* Banner with image and overlay text */}
          <div className='smart-tools-banner'>
            <div className='banner-image-container'>
              <img 
                src={Banner5} 
                alt="Smart Tools Banner" 
                className='smart-tools-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='smart-tools-title'>APP STORE DOWNLOAD</h2>
              </div>
            </div>
          </div>

          
        </div>

        {/* Available Now Section */}
        <div className='available-now-section'>
          <div className='available-container'>
            {/* Centered Image Banner */}
            <div className='available-image-container'>
              <img src={Image10} alt="Check-In App Interface" className='available-image' />
            </div>

            {/* Text Content Below Image (Left Aligned) */}
            <div className='available-text-content'>
              <div className='available-text-line'></div>
              <h2 className='available-title'>AVAILABLE NOW</h2>
              <p className='available-description'>
                Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
              </p>
            </div>
          </div>
        </div>
         <div className='smart-tools-section'>
          {/* Banner with image and overlay text */}
          <div className='smart-tools-banner'>
            <div className='banner-image-container'>
              <img 
                src={Banner6} 
                alt="Smart Tools Banner" 
                className='smart-tools-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='smart-tools-title'>ROLLING OUT NFC MEMBERSHIP CARDS</h2>
              </div>
            </div>
          </div>

          
        </div>

        {/* NFC Enabled Section */}
        <div className='nfc-enabled-section'>
          <div className='nfc-container'>
            <div className='nfc-image-content'>
              <img src={Image11} alt="NFC Device and Phone" className='nfc-image' />
            </div>

            <div className='nfc-text-content'>
              <p className='nfc-intro'>
                We're excited to introduce NFC-enabled membership cards. 
                To get started, your company must meet the following requirements:
              </p>
              
              <ul className='nfc-requirements'>
                <li>Be upgraded to K8 (our latest portal version)</li>
                <li>Use certified NFC readers (currently in beta)</li>
                <li>Have the next-gen Check-in app (beta version)</li>
                <li>Ensure existing members re-download their membership cards from the portal</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Webinar Banner Section */}
        <div className='webinar-banner-section'>
          <div className='webinar-banner-container'>
            <img 
              src={Banner7} 
              alt="Webinar Banner Background" 
              className='webinar-banner-bg'
            />
            <div className='webinar-banner-overlay'>
              <div className='webinar-banner-content'>
                <h2 className='webinar-title'>
                  SEE THE <span className='highlight'>CHECK-IN APP</span> IN ACTION
                </h2>
                <p className='webinar-subtitle'>watch the webinar and explore FAQs</p>
                <div className='webinar-button-container'>
                  <img 
                    src={WebinarButton} 
                    alt="View Webinar + FAQs" 
                    className='webinar-button-image'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA Section */}
        <div className='final-cta-section'>
          <div className='final-cta-container'>
            {/* Logo */}
            <div className='cta-logo-container'>
              <img 
                src={PeopleVineLogo} 
                alt="PeopleVine Logo" 
                className='peoplevine-logo'
              />
            </div>

            {/* Green Background Box with Text */}
            <div className='green-cta-box'>
              <h2 className='cta-title'>
                Ready to elevate the<br />
                "Welcome" experience<br />
                with all-new Check-In App?
              </h2>
            </div>

            {/* Bottom Description */}
            <div className='cta-description-container'>
              <p className='cta-description'>
                Contact your Account Manager to learn more about how our<br />
                <strong>Check-In</strong> can elevate your Front of House operations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Version */}
      <section className='check-in-page-mobile'>
        {/* Main Mobile Banner */}
        <div className='mobile-main-banner'>
          <img 
            src={MobileBanner} 
            alt="Check In Mobile Banner" 
            className='mobile-main-banner-img'
          />
          <div className='mobile-main-banner-overlay'>
            <div className='mobile-main-banner-content'>
              <h1 className='mobile-main-title'>CHECK-IN</h1>
              <p className='mobile-main-subtitle'>AN ELEVATED "WELCOME" FOR HOSPITALITY BRANDS</p>
             
            </div>
            
          </div>
           <p className='mobile-main-description'>
                At PeopleVine, we believe every interaction matters.
                That's why we created Check-in—our groundbreaking
                front-of-house app, developed in collaboration with the
                world's most discerning clubs to redefine personalized
                service and guest recognition
              </p>
              <h2 className='mobile-main-tagline'>A VIP WELCOME, EVERY TIME</h2>
        </div>

        {/* Easy & Convenient Stack */}
        <div className='mobile-stack-section'>
          <div className='mobile-stack-header'>
            <img 
              src={MobileBanner1} 
              alt="Easy & Convenient" 
              className='mobile-stack-header-img'
            />
            <div className='mobile-stack-header-content'>
              <h2 className='mobile-stack-header-title'>
                EASY & CONVENIENT MEMBER<br/>
                LOOKUP & CHECK - IN<br/>
                VIA SEARCH, CAMERA OR SCAN
              </h2>
            </div>
          </div>

          <div className='mobile-stack-items'>
            <div className='mobile-stack-item'>
              <img src={MobileImage1} alt="Search" className='mobile-stack-item-img' />
              <div className='mobile-stack-item-content'>
                <h3 className='mobile-stack-item-title'>SEARCH</h3>
                <p className='mobile-stack-item-description'>
                  Quickly look up members by name or email with smart search functionality. Front-of-house staff can instantly access profiles, confirm reservations, and check members in—ensuring smooth arrivals with just a few keystrokes.
                </p>
              </div>
            </div>

            <div className='mobile-stack-item'>
              <img src={MobileImage2} alt="Camera" className='mobile-stack-item-img' />
              <div className='mobile-stack-item-content'>
                <h3 className='mobile-stack-item-title'>CAMERA</h3>
                <p className='mobile-stack-item-description'>
                  Enable seamless check-ins using camera recognition. Simply hold up a membership card or digital pass for instant member identification, reducing friction and making arrivals fast and contactless.
                </p>
              </div>
            </div>

            <div className='mobile-stack-item'>
              <img src={MobileImage3} alt="Scan" className='mobile-stack-item-img' />
              <div className='mobile-stack-item-content'>
                <h3 className='mobile-stack-item-title'>SCAN</h3>
                <p className='mobile-stack-item-description'>
                  Check in members with a simple tap or scan using NFC, QR codes or barcodes. Ideal for concierge desks and secure entry points. Fast, discreet and effortlessly elegant.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Smart Tools Stack */}
        <div className='mobile-stack-section'>
          <div className='mobile-stack-header'>
            <img 
              src={MobileBanner2} 
              alt="Smart Tools" 
              className='mobile-stack-header-img'
            />
            <div className='mobile-stack-header-content'>
              <h2 className='mobile-stack-header-title'>
                SMART TOOLS FOR
                EXCEPTIONAL<br/> HOSPITALITY
              </h2>
            </div>
          </div>

          <div className='mobile-stack-items'>
            <div className='mobile-stack-item'>
              <img src={MobileImage4} alt="Check In Members" className='mobile-stack-item-img' />
              <div className='mobile-stack-item-content'>
                <h3 className='mobile-stack-item-title'>CHECK IN MEMBERS WITH PHOTO FOR RECOGNITION</h3>
                <p className='mobile-stack-item-description'>
                  Instantly recognize members and streamline arrivals with real-time data delivered to your front-of-house. From greeting by name to guiding them to their table, service, or amenity. Check-in ensures every member feels like a VIP the moment they walk in.
                </p>
              </div>
            </div>

            <div className='mobile-stack-item'>
              <img src={MobileImage5} alt="Guest Passes" className='mobile-stack-item-img' />
              <div className='mobile-stack-item-content'>
                <h3 className='mobile-stack-item-title'>INNOVATIVE GUEST PASSES AND WAITLIST CAPABILITIES</h3>
                <p className='mobile-stack-item-description'>
                  Streamline guest pass management with real-time tracking and visibility. Linked to member profiles, it ensures every guest feels expected and valued—enhancing the experience from the moment they arrive.
                </p>
              </div>
            </div>

            <div className='mobile-stack-item'>
              <img src={MobileImage6} alt="CRM Profiles" className='mobile-stack-item-img' />
              <div className='mobile-stack-item-content'>
                <h3 className='mobile-stack-item-title'>POWERFUL CRM PROFILES</h3>
                <p className='mobile-stack-item-description'>
                  One-click access to detailed CRM profiles enables rapid retrieval of membership data, insights and preferences, empowering personalized service.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Empower Front of House */}
        <div className='mobile-empower-section'>
          <img 
            src={MobileBanner3} 
            alt="Empower Front of House" 
            className='mobile-empower-img'
          />
          <div className='mobile-empower-content'>
            <h2 className='mobile-empower-title'>EMPOWER YOUR FRONT-OF-HOUSE <br/>TEAM</h2>
            <p className='mobile-empower-description'>
              Enhance the welcome experience by enabling your staff to greet members with personalized service.
            </p>
          </div>
        </div>

        {/* Refined Features List */}
        <div className='mobile-refined-features'>
          <div className='mobile-refined-item'>
            <div className='mobile-refined-image'>
            <img src={MobileImage7} alt="Interface" className='mobile-refined-image-item custom-img' />
          </div>
            
            
            <h3 className='mobile-refined-title'>REFINED USER INTERFACE</h3>
            <p className='mobile-refined-description'>
              An intuitive and visually improved design streamlines usability, enhancing the experience for both staff and members.
            </p>
          </div>

          <div className='mobile-refined-item'>
            <div className='mobile-refined-line'></div>
            <h3 className='mobile-refined-title'>REAL-TIME CHECK-IN VISIBILITY</h3>
            <p className='mobile-refined-description'>
              Track daily check-ins live, monitor member flow, and optimize staffing for peak times to enhance service delivery.
            </p>
          </div>

          <div className='mobile-refined-item'>
            <div className='mobile-refined-line'></div>
            <h3 className='mobile-refined-title'>FLEXIBLE CHECK-IN POINTS</h3>
            <p className='mobile-refined-description'>
              Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
            </p>
          </div>

          
        </div>

        {/* Booking & Reservations */}
        <div className='mobile-booking-header'>
          <img 
            src={MobileBanner4} 
            alt="Booking & Reservations" 
            className='mobile-booking-header-img'
          />
          <div className='mobile-booking-header-content'>
            <h2 className='mobile-booking-header-title'>BOOKING & RESERVATIONS</h2>
          </div>
        </div>

        {/* Booking Details */}
        <div className='mobile-booking-section'>
          <img src={MobileImage8} alt="Booking Details" className='mobile-booking-img' />
          <div className='mobile-booking-content'>
            <h3 className='mobile-booking-title'>BOOKINGS & RESERVATIONS DETAILS</h3>
            <p className='mobile-booking-description'>
              Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
            </p>
          </div>
        </div>

        {/* Booking Itinerary */}
        <div className='mobile-itinerary-section'>
          <img src={MobileImage9} alt="Itinerary" className='mobile-itinerary-img' />
          <div className='mobile-itinerary-content'>
            <h3 className='mobile-itinerary-title'>BOOKINGS & ITINERARY</h3>
            <p className='mobile-itinerary-description'>
              Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
            </p>
          </div>
         
        </div>

        {/* App Store Download */}
        <div className='mobile-app-store-header'>
          <img 
            src={MobileBanner5} 
            alt="App Store Download" 
            className='mobile-app-store-header-img'
          />
          <div className='mobile-app-store-header-content'>
            <h2 className='mobile-app-store-header-title'>APP STORE DOWNLOAD</h2>
          </div>
        </div>

        {/* Available Now */}
        <div className='mobile-available-section'>
          <img src={MobileImage10} alt="Available Now" className='mobile-available-img' />
          <div className='mobile-available-content'>
            <div className='mobile-available-line'></div>
            <h3 className='mobile-available-title'>AVAILABLE NOW</h3>
            <p className='mobile-available-description'>
              Easily configure multiple check-in locations to support varied operations, enhance oversight, and improve member convenience.
            </p>
          </div>
        </div>

        {/* NFC Membership Cards */}
        <div className='mobile-nfc-header'>
          <img 
            src={MobileBanner6} 
            alt="NFC Membership Cards" 
            className='mobile-nfc-header-img'
          />
          <div className='mobile-nfc-header-content'>
            <h2 className='mobile-nfc-header-title'>ROLLING OUT NFC MEMBERSHIP CARDS</h2>
          </div>
        </div>

        {/* NFC Details */}
        <div className='mobile-nfc-section'>
          <img src={MobileImage11} alt="NFC Details" className='mobile-nfc-img' />
          <div className='mobile-nfc-content'>
            <p className='mobile-nfc-intro'>
              We're excited to introduce NFC-enabled membership cards. To get started, your company must meet the following requirements:
            </p>
            <ul className='mobile-nfc-list'>
              <li>Be upgraded to K8 (our latest portal version)</li>
              <li>Use certified NFC readers (currently in beta)</li>
              <li>Have the next-gen Check-in app (beta version)</li>
              <li>Ensure existing members re-download their membership cards from the portal</li>
            </ul>
          </div>
        </div>

        {/* Webinar Section */}
        <div className='mobile-webinar-section'>
          <img 
            src={MobileBanner7} 
            alt="Webinar" 
            className='mobile-webinar-img'
          />
          <div className='mobile-webinar-overlay'>
            <div className='mobile-webinar-content'>
              <h2 className='mobile-webinar-title'>
                SEE THE <span className='mobile-webinar-highlight'>CHECK-IN APP</span> IN ACTION
              </h2>
              <p className='mobile-webinar-subtitle'>watch the webinar and explore FAQs</p>
              <div className='mobile-webinar-button'>
                <img 
                  src={WebinarButton} 
                  alt="View Webinar + FAQs" 
                  className='mobile-webinar-button-img'
                />
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className='mobile-final-section'>
          <div className='mobile-final-logo'>
            <img 
              src={PeopleVineLogo} 
              alt="PeopleVine Logo" 
              className='mobile-final-logo-img'
            />
          </div>

          <div className='mobile-final-cta-box'>
            <h2 className='mobile-final-cta-title'>
              Ready to elevate the<br/>
              "Welcome" experience<br/>
              with all-new Check-In App?
            </h2>
          </div>

          <div className='mobile-final-description'>
            <p className='mobile-final-description-text'>
              Contact your Account Manager to learn more about how our <strong>Check-In</strong> can elevate your Front of House operations.
            </p>
          </div>
        </div>
      </section>
    </DefaultLayout>
  )
}

export default CheckInPage
